let loadPromise = null;

// Prod: fetch the Vite manifest at the configured CDN base and resolve the
// single entry's hashed filename. Dev: load directly from the dev-server URL.
// The hashed URL is its own cache buster — no manual `?v=` bookkeeping.
async function resolveCheckoutScriptUrl(inDevEnv) {
  if (inDevEnv) {
    return process.env.VUE_APP_CHECKOUT_URL;
  }
  const base = process.env.VUE_APP_CHECKOUT_CDN_BASE;
  const res = await fetch(`${base}/.vite/manifest.json`);
  if (!res.ok) throw new Error(`checkout manifest fetch failed: ${res.status}`);
  const manifest = await res.json();
  // Lib-mode IIFE always emits a single entry — pick it by isEntry rather than
  // hardcoding the entry path (an internal Vite build detail).
  const entry = Object.values(manifest).find((e) => e && e.isEntry);
  if (!entry || !entry.file) throw new Error('checkout manifest has no entry');
  return `${base}/${entry.file}`;
}

export function loadCheckoutScript({ inDevEnv } = {}) {
  if (loadPromise) return loadPromise;
  if (customElements.get('mcs-checkout')) {
    loadPromise = Promise.resolve();
    return loadPromise;
  }

  loadPromise = (async () => {
    const url = await resolveCheckoutScriptUrl(inDevEnv);
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.setAttribute('data-checkout-app', '');
      script.src = url;
      if (inDevEnv) {
        script.type = 'module';
        script.crossOrigin = 'anonymous';
      }
      script.onload = () => resolve();
      script.onerror = () => {
        loadPromise = null;
        reject(
          new Error(
            'Failed to load checkout script (is `npm run dev:all` running in MyCreativeShop.CheckoutApp?)'
          )
        );
      };
      document.head.appendChild(script);
    });
  })();
  // Re-arm on failure so a retry can try again.
  loadPromise.catch(() => {
    loadPromise = null;
  });
  return loadPromise;
}
